export default __webpack_public_path__ + "static/media/bz.8c10af1e.svg";